import * as types from '../actions/types';
import initialState from './initialState';
import { default as config } from '../constants';


export default function budgetReducer(state = initialState.budgets, action) {
	// For these specific actions i want to manipulate state in this
	// way...
	switch (action.type) {
		case types.LOAD_CALCULATORS_SUCCESS:
			let result = [];
			action.budgets.forEach(element => {
				let l = [];
				element.acf.budget_items.forEach(e => { 
					l.push({id: e.line_item});
				});
				result.push({title: element.acf.budget_title, id: element.id, image: element.acf.budget_feature_image, lines: [...l]});
			});
			return [...result];
		case types.LOAD_CALCULATORS_FAILURE:
			return state
		case types.RESET_CALCULATOR_SUCCESS:
			//return Object.assign({}, initialState.budgets);
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/budgetReducer.js